// Copyright (C) 2012-present, The Authors. This program is free software: you can redistribute it and/or  modify it under the terms of the GNU Affero General Public License, version 3, as published by the Free Software Foundation. This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU Affero General Public License for more details. You should have received a copy of the GNU Affero General Public License along with this program.  If not, see <http://www.gnu.org/licenses/>.

// Polis timestamps are epoch milliseconds, but some write paths (notably the
// math service after processing a conversation) store `modified` in
// MICROSECONDS instead. A naive `new Date(microseconds)` then renders a
// nonsense far-future year (e.g. 58692). This normalizes any of:
//   - a number or numeric string
//   - milliseconds (13 digits) or microseconds (16 digits)
// to a millisecond value suitable for `new Date(...)`. Returns null when the
// input is missing or unparseable.
export function toMillis(ts) {
  const n = typeof ts === 'string' ? parseInt(ts, 10) : Number(ts)
  if (!n || Number.isNaN(n)) return null
  // A millisecond epoch stays ~1e12–1e13 for any realistic date; anything above
  // ~1e14 is microseconds (or finer) and must be scaled down.
  let ms = n
  while (ms > 1e14) ms = Math.floor(ms / 1000)
  return ms
}

// Convenience: format a Polis timestamp as a localized date, tolerating the
// microsecond bug. Returns a dash for missing/invalid values.
export function formatDate(ts, locale, options) {
  const ms = toMillis(ts)
  if (ms == null) return '—'
  return new Date(ms).toLocaleDateString(
    locale,
    options || { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' }
  )
}
